import _ from 'lodash';
import NamedDto from 'modules/base/dto/NamedDto';

export default class MeasurementEditDto extends NamedDto {
	constructor() {
		super();
		/** @type {number} */
		this.device = null;
		/** @type {string} */
		this.recordingType = null;
		/** @type {number} */
		this.recordTimeInSec = null;
	}

	/**
	 * @typedef {Object} _MeasurementEditDtoProps
	 * @property {number} device
	 * @property {StringMap} recordingType
	 * @property {number} recordTimeInSec
	 *
	 * @typedef {import("modules/base/dto/NamedDto").NamedDtoProps & _MeasurementEditDtoProps} MeasurementEditDtoProps
	 */
	/**
	 *
	 * @param {MeasurementEditDtoProps} props
	 * @returns {MeasurementEditDto}
	 */
	setup(props) {
		super.setup(props);
		this.device = props.device;
		this.recordingType = props.recordingType;
		this.recordTimeInSec = props.recordTimeInSec;
		return this;
	}
}
